//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["logicalObject"],"CreateNonMasterListForLogicalObject",{},1,0],[["logicalObject","numParts"],"GetNonMasterListForCopyLogicalObject",{R_:{partFileNames:""}},1,0],[["logicalObject","part_name"],"IsNonMasterForLogicalObjectBeingCopied",{R_:{do_save_as:''}},2,0],[["logicalObject"],"GetCopyNonMasterPartsOption",{R_:{saveOption:''}},1,0],[["logicalObject","saveOption"],"SetNonMasterSaveAsOption",{},2,0],[["logicalObject","partName"],"SetSelectedNonMasterToCopy",{},2,0],[["logicalObject","oldName","newName"],"EditNonMasterToCopyName",{R_:{isNameValid:''}},3,0]],[]];
SPLM.PDM.NonMasterData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.NonMasterData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.NonMasterData.CopyNonMasterPartsOption = Object.freeze({
    "All" : "All", "None" : "None"});

export default SPLM;